import { useContext } from 'react';
import {SocketContext} from '../contexts/SocketContext';

export default function useSocket() {
    const value = useContext(SocketContext);
    return value;
}